export const getCustomerMockedData: any = {
  // there are more fields in the actual response, but we only need these for now
  // it's probably better have here only what we need because data types and names change too often now
  // when the whole CMD system is stabilised, we can add the full response here
  companyName: 'test company',
  id: '123',
}

export const successfulResponse = { status: 200 }
